import { FC, ReactNode } from 'react';
import * as InfoTool from '@radix-ui/react-tooltip';
import { Icons } from './icons';
import { cn } from '@/utils/cn';

interface InfoToolProps {
  children: ReactNode;
  width?: number;
  iconColor?: string;
  additionalMarginBottom?: boolean;
}

interface InfoIconProps {
  iconColor: string | undefined;
}

const InfoIcon = ({ iconColor }: InfoIconProps) => <Icons.info className={cn('size-4', iconColor ? iconColor : 'text-text-primary')} />;

const Tooltip: FC<InfoToolProps> = ({ children, width, iconColor, additionalMarginBottom }) => {
  return (
    <>
      {/* mobile: just icon without tooltip functionality */}
      <div className='lg:hidden p-1.5' aria-label='Information'>
        <InfoIcon iconColor={iconColor} />
      </div>
      {/* desktop: full tooltip functionality */}
      <div className='hidden lg:block'>
        <InfoTool.Provider delayDuration={0}>
          <InfoTool.Root>
            <InfoTool.Trigger asChild>
              <div className='p-1.5 cursor-help'>
                <InfoIcon iconColor={iconColor} />
              </div>
            </InfoTool.Trigger>
            <InfoTool.Portal>
              <InfoTool.Content
                className='data-[state=delayed-open]:data-[side=top]:animate-slideDownAndFade data-[state=delayed-open]:data-[side=right]:animate-slideLeftAndFade data-[state=delayed-open]:data-[side=left]:animate-slideRightAndFade data-[state=delayed-open]:data-[side=bottom]:animate-slideUpAndFade select-none rounded-lg px-4 py-2 will-change-[transform,opacity] bg-border-primary z-50'
                sideOffset={additionalMarginBottom ? 0 : -5}
                style={{
                  width: width || 'auto',
                }}
              >
                {children}
                <InfoTool.Arrow className='fill-border-primary' />
              </InfoTool.Content>
            </InfoTool.Portal>
          </InfoTool.Root>
        </InfoTool.Provider>
      </div>
    </>
  );
};

export default Tooltip;
